import { render, staticRenderFns } from "./ResetPasswordCallback.vue?vue&type=template&id=09044399&"
import script from "./ResetPasswordCallback.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordCallback.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordCallback.vue?vue&type=style&index=0&id=09044399&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports